import {axiosPostHandler} from '_root/miniprogram/common/request.js'

export function MPGetSMToken (formdata) {
	let url = '/rc/box_data/callback'
	return axiosPostHandler(url, {}, formdata, 'heybox')
}